import { useEffect } from "react";
import { useOrganizationState } from "../context/context-organization";

export function useUpdateSelectedOrganization(id?: string | null): void {
  const {
    loading,
    organizations,
    setSelectedOrganization,
    selectedOrganization,
  } = useOrganizationState();

  useEffect(
    function effectOnUpdateSelectedOrganization() {
      if (loading !== "succeeded") {
        return;
      }

      if (id && Array.isArray(organizations) && organizations.length > 0) {
        const organization = organizations.find((org) => org.id === id);
        if (organization && selectedOrganization?.id !== organization.id) {
          setSelectedOrganization(organization);
        }
      }
    },
    [
      id,
      loading,
      organizations,
      selectedOrganization?.id,
      setSelectedOrganization,
    ],
  );
}
